import Skeleton from "@mui/material/Skeleton";
import React from "react";
import Box from "@mui/material/Box";
import RateReviewIcon from '@mui/icons-material/RateReview';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useHistory } from "react-router-dom";
import CourseRewards from "./mycourses/CourseRewards";
import ProgressTracker from "./mycourses/ProgressTracker";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import dateFormat from "dateformat";
import defaultdp from "../../assets/icons/defaultdp.svg";
import DetectDevice from "../../data/DetectDevice";
import CourseDashboardStats from "../../actions/CourseDashboardStats";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useState } from "react";
import Localbase from "localbase";
import SetPage from "../../data/SetPage";
import TrackJourney from "../../actions/course/TrackJourney";
import ModalStyle from "../../data/ModalStyle";
import myclasses from "../../assets/dashboard/classes.svg";
import notesicon from "../../assets/dashboard/notes.svg";
import assignmentsicon from "../../assets/dashboard/assignments.svg";
import recordingsicon from "../../assets/dashboard/recordings.svg";
import projectsicon from "../../assets/dashboard/projects.svg";
import rewardsicon from "../../assets/dashboard/rewards.svg";
import supporticon from "../../assets/dashboard/support.svg";
import placementicon from "../../assets/dashboard/placement.svg";
import Alert from "@mui/material/Alert";
import PaidIcon from '@mui/icons-material/Paid';

import ClassItem from "./mycourses/ClassItem";
import TeamLeaderboard from "./mycourses/TeamLeaderboard";
import { Download } from "@mui/icons-material";
import CourseBatchChat from "./CourseBatchChat";
import teamicon from "../../assets/images/teamicon.svg";
import ClassesCalander from "./mycourses/ClassesCalander";
import PreviousScheduleItem from "./PreviousScheduleItem";
import UploadStudentIdCard from "./UploadStudentIdCard";
import IDCardRequest from "./IDCardRequest";
import axios from "axios";
import ENDPOINT from "../../data/ENDPOINT";
import SecurityHeaders from "../../data/SecurityHeaders";
import styled from "styled-components";
import WeeklyFeedback from "../../components/modals/WeeklyFeedback";

import { User, CreditCard, Badge, Star, Video, FileText, BookOpen, ClipboardList, FolderOpen, Gift, HelpCircle, Briefcase, Coins, TestTube, Database, Award } from "lucide-react";
import { get } from "@firebase/database";

const MyCourseDashboard = ({ account }) => {
  const history = useHistory();
  const params = useParams();
  const course_url = params.course_url;
  const batch_id = params.batch_id;
  const { user } = useContext(AuthContext);
  const [loading, setloading] = useState(true);
  const [previous_classes, setpreviousclasses] = useState([]);
  
  useEffect(() => {
    window.scrollTo(0, 0);
    CourseJourney();
  }, []);
  
  let db = new Localbase("db");
  const [course, setcourse] = useState(null);
  const [classes, setclasses] = useState(null);
  const [recordings, setrecordings] = useState(null);
  const [lessons, setlessons] = useState(null);
  const [learnings, setlearnings] = useState(null);
  const [upcominClasses, setUpcomingClasses] = useState([]);
  const [activeassignments, setAssignments] = useState([]);
  
  const Statistics = async () => {
    const res = await CourseDashboardStats({
      payload: {
        user: user.SessionId,
        course_url: course_url,
        batch_id: batch_id,
      },
    });

    if (res) {
      if (res.status === "success") {
        setlessons(res.lessons);
        setcourse(res.course);
        setclasses(res.classes);
        setrecordings(res.recordings);
        setlearnings(res.learnings);
        setloading(false);

        let path = "course_" + course_url;
        db.collection("paths").add(
          {
            my_course: res.course,
          },
          "my_course",
        );
        db.collection("paths").add(
          {
            classes: res.classes,
          },
          "classes",
        );

        db.collection("paths").add(
          {
            recordings: res.recordings,
          },
          "recordings",
        );

        Animate();
      }
    }
  };

  useEffect(() => {
    SetPage("My Course");
    db.collection("paths")
      .doc("my_course")
      .get()
      .then((course) => {
        setcourse(course.my_course);
      })
      .catch((error) => { });

    db.collection("paths")
      .doc("classes")
      .get()
      .then((course) => {
        setclasses(course.classes);
      })
      .catch((error) => { });

    db.collection("paths")
      .doc("recordings")
      .get()
      .then((course) => {
        setrecordings(course.recordings);
      })
      .catch((error) => { });
    Statistics();
  }, []);

  const newdevice = DetectDevice();
  const [cart, setsestate] = useState();
  const [journey, setjourney] = useState(null);
  const [doubtStatistics, setDoubtStatistics] = useState({
    doubt_limit: 3000,
    doubt_score: 0,
    request_permission: true
  });

  const navigationItems = [
    {
      id: 'classes',
      label: 'Classes',
      info: "Join live and upcoming sessions",
      icon: Video,
      color: '#3b82f6',
      hoverClass: 'hover-shortcut-blue',
      bgColor: 'rgba(59, 130, 246, 0.1)',
      link: `/classes/${course_url}/batch${batch_id}`,
    },
    {
      id: 'recordings',
      label: 'Recordings',
      info: "Watch previously conducted classes",
      icon: FileText,
      color: '#8b5cf6',
      hoverClass: 'hover-shortcut-purple',
      bgColor: 'rgba(139, 92, 246, 0.1)',
      link: `/recordings/${course_url}/${batch_id}/0`,
    },
    {
      id: 'assignments',
      label: 'Assignments',
      info: "Practice with assigned tasks",
      icon: ClipboardList,
      color: '#f97316',
      hoverClass: 'hover-shortcut-orange',
      bgColor: 'rgba(249, 115, 22, 0.1)',
      link: `/assignments/${course_url}/${batch_id}`,
    },
    {
      id: 'projects',
      label: 'Projects',
      info: "Build real-world projects",
      icon: FolderOpen,
      color: '#ef4444',
      hoverClass: 'hover-shortcut-red',
      bgColor: 'rgba(239, 68, 68, 0.1)',
      link: `/projects/${course_url}/${batch_id}`,
    },
    {
      id: 'support',
      label: 'Support',
      info: "Get help from trainers and support",
      icon: HelpCircle,
      color: '#6366f1',
      hoverClass: 'hover-shortcut-indigo',
      bgColor: 'rgba(99, 102, 241, 0.1)',
      link: `/trainer-support/${course_url}/${batch_id}`,
    },
    {
      id: 'placements',
      label: 'Placements',
      info: "Prepare for jobs and placements",
      icon: Briefcase,
      color: '#14b8a6',
      hoverClass: 'hover-shortcut-teal',
      bgColor: 'rgba(20, 184, 166, 0.1)',
      link: `/placement-cell/${course_url}/${batch_id}`,
    },
  ];

  const CourseJourney = async () => {
    const res = await TrackJourney({
      payload: {
        user: user.SessionId,
        course_url: course_url,
        batch_id: batch_id,
      },
    });
    if (res) {
      if (res.status === "success" && res.data != null) {
        setjourney(res.data);
      }
    }
  };

  const Animate = () => {
    const items = document.getElementsByClassName("animate");
    const screenheight = window.innerHeight;
    for (var i = 0; i <= items.length; i++) {
      const currentelement = items[i];
      if (currentelement) {
        const elementposition = parseInt(
          currentelement.getBoundingClientRect().top.toFixed(),
        );
        if (elementposition < screenheight) {
          if (items[i].classList.contains("animation-active")) {
          } else {
            items[i].classList.add("animation-active");
          }
        }
      }
    }
  };
  
  const device = DetectDevice();
  useEffect(() => {
    SetPage("My Course");
  }, []);

  const [modal, setmodal] = useState(false);

  const DownloadIdCard = ({ data }) => {
    const imageUrl = data.id_card;
    fetch(imageUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "skillsupriseethical-hacking-specialization.png";
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error downloading the image:", error);
      });
  };

  const [videoPermission, setVideoPermission] = useState('active');
  const [weeklyFeedback, setWeeklyFeedback] = useState(false);

  const checkWeekFeedback = async () => {
    try {
      const data = new FormData();
      data.append("session", user.SessionId);
      const response = await axios.post(ENDPOINT + "check-saturday-feedback.php", data, SecurityHeaders);
      if (response.data.status) {
        setWeeklyFeedback(response.data.status);
      }
    } catch (error) {
      console.error("Error getting user media: ", error);
      return false;
    }
  };

  const checkVideoPermission = async () => {
    try {
      const data = new FormData();
      data.append("session", user.SessionId);
      const response = await axios.post(ENDPOINT + "check_course_dashboard_video_permission.php", data, SecurityHeaders);
      if (response.data.status === "success") {
        setVideoPermission(response.data.video_status);
      }
    } catch (error) {
      console.error("Error getting user media: ", error);
      return false;
    }
  };

  const getvideos = async () => {
    if (!user.SessionId) {
      setloading(false);
      return;
    }
    try {
      const response = await fetch(
        `${ENDPOINT}get-recording.php?id=0&session=${user.SessionId}&batch_id=${batch_id}&course_url=${course_url}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const result = await response.json();
      if (result.status === "error") {
        throw new Error(result.message);
      }
      setpreviousclasses(result.previous_classes);
    } catch (error) {
      // handle error
    } finally {
      setloading(false);
    }
  };

  const getClasses = async () => {
    if (!user.SessionId) return;
    try {
      const formData = new FormData();
      formData.append("session", user.SessionId);
      formData.append("batch_id", batch_id);
      formData.append("course_url", course_url);
      formData.append("status", "incomplete");

      const res = await fetch(`${ENDPOINT}live-schedule.php`, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        console.warn("Live schedule API failed:", res.status);
        return;
      }

      const data = await res.json();
      if (data.status === "success") {
        setUpcomingClasses(data.data);
      } else {
        setUpcomingClasses([]);
      }
    } catch (error) {
      console.error("Live schedule error:", error.message);
      setUpcomingClasses([]);
    }
  };

  useEffect(() => {
    checkVideoPermission();
    checkWeekFeedback();
    getvideos();
    getClasses();
  }, [user.SessionId]);

  const updateVidePermissions = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append("session", user.SessionId);
      const response = await axios.post(ENDPOINT + "course_dashboard_video_permission.php", data, SecurityHeaders);
      if (response.data.status === "success") {
        setVideoPermission("active");
      }
    } catch (error) {
      console.error("Error updating video permissions: ", error);
    }
  };

  const handleWeeklyFeedback = (e) => {
    setWeeklyFeedback(false);
  };

  return (
    <div className="dashboard-wrapper">
      <style>{`
        .dashboard-wrapper {
          background-color: #f3f4f6;
          min-height: 100vh;
          padding-top: 20px !important;
          padding-bottom: 48px;
        }

        @media (max-width: 767px) {
          .dashboard-wrapper {
            /* clear the fixed header (~60px) + a neat gap */
            padding-top: 76px !important;
          }
        }

        /* Luxury Profile Card / Welcome Hero Styling */
        .luxury-card {
          background: linear-gradient(135deg, rgba(255, 253, 250, 0.92) 0%, rgba(255, 208, 168, 0.88) 100%);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.7);
          border-radius: 24px;
          box-shadow: 0 10px 35px rgba(249, 115, 22, 0.05);
          position: relative;
          overflow: hidden;
        }

        .bg-blur-circle {
          position: absolute;
          width: 220px;
          height: 220px;
          background: radial-gradient(circle, rgba(249, 115, 22, 0.12) 0%, rgba(249, 115, 22, 0) 70%);
          filter: blur(30px);
          pointer-events: none;
          z-index: 0;
        }

        .bg-blur-circle-alt {
          position: absolute;
          width: 220px;
          height: 220px;
          background: radial-gradient(circle, rgba(253, 186, 116, 0.1) 0%, rgba(253, 186, 116, 0) 70%);
          filter: blur(30px);
          pointer-events: none;
          z-index: 0;
        }

        /* Floating White Balls */
        .white-ball {
          position: absolute;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.6);
          box-shadow: inset -2px -2px 12px rgba(255, 255, 255, 0.95), 
                      0 8px 24px rgba(249, 115, 22, 0.03);
          backdrop-filter: blur(2px);
          pointer-events: none;
          z-index: 0;
        }
        .white-ball-1 {
          width: 130px;
          height: 130px;
          top: -30px;
          right: 15%;
        }
        .white-ball-2 {
          width: 90px;
          height: 90px;
          bottom: -20px;
          left: 10%;
        }
        .white-ball-3 {
          width: 60px;
          height: 60px;
          top: 40px;
          left: 35%;
          opacity: 0.8;
        }

        /* Simple Gray border instead of gradient of violet and purple border for profile pic */
        .bg-gradient-ring {
          background: #e2e8f0;
          padding: 2px;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        }

        .profile-inner {
          background: white;
          border-radius: 16px;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .text-gradient {
          background: linear-gradient(45deg, #3b82f6, #8b5cf6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-size: 1.8rem;
          font-weight: 800;
        }

        .text-gradient-heading {
          background: linear-gradient(45deg, #0f172a, #334155);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-weight: 850;
        }

        .badge-status-pro {
          background: rgba(16, 185, 129, 0.1);
          color: #10b981;
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
          padding: 6px 12px;
          border-radius: 99px;
          border: 1px solid rgba(16, 185, 129, 0.18);
          letter-spacing: 0.05em;
        }

        .btn-hero-action {
          background: white;
          color: #374151;
          border: 1px solid #d1d5db;
          font-size: 12.5px;
          font-weight: 600;
          padding: 8px 14px;
          border-radius: 10px;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: all 0.2s ease;
          cursor: pointer;
        }

        .btn-hero-action:hover {
          background: #f9fafb;
          border-color: #9ca3af;
          transform: translateY(-1px);
        }

        /* Continue Learning Button Color changed to Orange, Text to Black */
        .btn-hero-action-primary {
          background: #f97316 !important;
          color: #000000 !important;
          border-color: #f97316 !important;
          box-shadow: 0 4px 12px rgba(249, 115, 22, 0.2) !important;
        }

        .btn-hero-action-primary:hover {
          background: #ea580c !important;
          border-color: #ea580c !important;
          color: #000000 !important;
          box-shadow: 0 6px 16px rgba(249, 115, 22, 0.3) !important;
        }

        /* Sub Stats Cards - center items on all screen sizes */
        .hero-sub-card {
          background: white !important;
          border-radius: 16px !important;
          padding: 14px !important;
          display: flex;
          flex-direction: column;
          align-items: center !important;
          text-align: center !important;
          gap: 4px;
          transition: all 0.3s ease;
          border: 1.5px solid transparent !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.01) !important;
        }

        .hero-sub-card .d-flex {
          justify-content: center !important;
        }

        .hero-sub-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04) !important;
        }

        .border-orange { border-color: rgba(249, 115, 22, 0.15) !important; }
        .border-yellow { border-color: rgba(245, 158, 11, 0.15) !important; }
        .border-blue { border-color: rgba(59, 130, 246, 0.15) !important; }
        .border-green { border-color: rgba(34, 197, 94, 0.15) !important; }

        .sub-card-icon-dot {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
        }
        .sub-card-icon-dot.orange { background-color: #f97316; }
        .sub-card-icon-dot.yellow { background-color: #f59e0b; }
        .sub-card-icon-dot.blue { background-color: #3b82f6; }
        .sub-card-icon-dot.green { background-color: #22c55e; }

        .sub-card-label {
          font-size: 10px;
          font-weight: 700;
          color: #6b7280;
          letter-spacing: 0.05em;
        }

        .sub-card-value {
          font-size: 1.25rem;
          font-weight: 800;
          color: #1f2937;
          margin: 2px 0;
        }

        .sub-card-unit {
          font-size: 0.8rem;
          font-weight: 500;
          color: #9ca3af;
        }

        .sub-card-badge {
          display: inline-block;
          font-size: 9.5px;
          font-weight: 600;
          padding: 2px 8px;
          border-radius: 99px;
          width: fit-content;
        }

        .sub-card-badge.orange {
          border: 1px solid rgba(249, 115, 22, 0.2);
          color: #f97316;
          background: rgba(249, 115, 22, 0.04);
        }
        .sub-card-badge.yellow {
          border: 1px solid rgba(245, 158, 11, 0.25);
          color: #f59e0b;
          background: rgba(245, 158, 11, 0.04);
        }
        .sub-card-badge.blue {
          border: 1px solid rgba(59, 130, 246, 0.2);
          color: #3b82f6;
          background: rgba(59, 130, 246, 0.04);
        }
        .sub-card-badge.green {
          border: 1px solid rgba(34, 197, 94, 0.2);
          color: #22c55e;
          background: rgba(34, 197, 94, 0.04);
        }

        /* Shortcuts Layout */
        .nav-shortcut-card {
          background: white !important;
          border-radius: 20px !important;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.03) !important;
          text-decoration: none !important;
          border: 1.5px solid transparent !important;
        }

        .nav-shortcut-card:hover {
          transform: translateY(-5px) !important;
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08) !important;
        }

        .nav-shortcut-icon-wrapper {
          width: 46px;
          height: 46px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          transition: transform 0.3s ease, background-color 0.3s ease, color 0.3s ease;
        }

        .nav-shortcut-card:hover .nav-shortcut-icon-wrapper {
          transform: scale(1.1) rotate(3deg);
        }

        .nav-shortcut-title {
          font-size: 14.5px;
          font-weight: 700;
          color: #1f2937 !important;
          letter-spacing: -0.01em;
        }

        .nav-shortcut-desc {
          font-size: 11.5px;
          color: #6b7280 !important;
        }

        /* Hover states */
        .hover-shortcut-blue:hover { border-color: rgba(59, 130, 246, 0.2) !important; background: linear-gradient(180deg, #ffffff 0%, rgba(59, 130, 246, 0.05) 100%) !important; }
        .hover-shortcut-purple:hover { border-color: rgba(139, 92, 246, 0.2) !important; background: linear-gradient(180deg, #ffffff 0%, rgba(139, 92, 246, 0.05) 100%) !important; }
        .hover-shortcut-orange:hover { border-color: rgba(249, 115, 22, 0.2) !important; background: linear-gradient(180deg, #ffffff 0%, rgba(249, 115, 22, 0.05) 100%) !important; }
        .hover-shortcut-red:hover { border-color: rgba(239, 68, 68, 0.2) !important; background: linear-gradient(180deg, #ffffff 0%, rgba(239, 68, 68, 0.05) 100%) !important; }
        .hover-shortcut-indigo:hover { border-color: rgba(99, 102, 241, 0.2) !important; background: linear-gradient(180deg, #ffffff 0%, rgba(99, 102, 241, 0.05) 100%) !important; }
        .hover-shortcut-teal:hover { border-color: rgba(20, 184, 166, 0.2) !important; background: linear-gradient(180deg, #ffffff 0%, rgba(20, 184, 166, 0.05) 100%) !important; }

        /* Media queries for widths <= 575px - shortcut changes */
        @media (max-width: 575px) {
          .nav-shortcut-card {
            flex-direction: column !important;
            text-align: center !important;
            justify-content: center !important;
            padding: 16px 8px !important;
            gap: 8px !important;
          }
          .nav-shortcut-icon-wrapper {
            margin: 0 auto !important;
          }
          .nav-shortcut-desc {
            display: none !important;
          }
        }

        /* Media queries for widths <= 767px - center buttons and sub-stats inside luxury-card */
        @media (max-width: 767px) {
          .luxury-card .d-flex.flex-column.flex-md-row {
            align-items: center !important;
            text-align: center !important;
          }
          .luxury-card .d-flex.align-items-center.gap-3 {
            flex-direction: column !important;
            align-items: center !important;
          }
          .luxury-card .d-flex.align-items-center.gap-2 {
            justify-content: center !important;
            width: 100% !important;
            margin-top: 12px;
          }
        }

        /* Banners with Image Backgrounds instead of green/orange gradients */
        .shortcut-banner {
          height: 110px;
          border-radius: 20px;
          overflow: hidden;
          display: flex;
          align-items: center;
          padding: 20px;
          color: #ffffff;
          text-decoration: none !important;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          border: 1px solid rgba(255, 255, 255, 0.15);
          position: relative;
        }

        .shortcut-banner:hover {
          transform: scale(1.02);
          box-shadow: 0 12px 25px rgba(0, 0, 0, 0.12);
        }

        .resource-banner {
          background-image: linear-gradient(135deg, rgba(15, 23, 42, 0.78) 0%, rgba(15, 23, 42, 0.48) 100%), 
                            url('https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?q=80&w=600&auto=format&fit=crop') !important;
          background-size: cover !important;
          background-position: center !important;
        }

        .exam-banner {
          background-image: linear-gradient(135deg, rgba(15, 23, 42, 0.78) 0%, rgba(15, 23, 42, 0.48) 100%), 
                            url('https://images.unsplash.com/photo-1434030216411-0b793f4b4173?q=80&w=600&auto=format&fit=crop') !important;
          background-size: cover !important;
          background-position: center !important;
        }

        .shortcut-banner h6 {
          font-size: 1.1rem;
          font-weight: 700;
          margin-bottom: 2px !important;
          text-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }

        .shortcut-banner p {
          font-size: 0.8rem;
          color: rgba(255, 255, 255, 0.85);
          text-shadow: 0 1px 2px rgba(0,0,0,0.25);
        }

        /* Cyber Sandbox Card */
        .cyber-lab-card {
          background: white;
          border-radius: 20px;
          border: 1.5px solid rgba(16, 185, 129, 0.2);
          position: relative;
          overflow: hidden;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.03);
        }

        .cyber-decor-top {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 4px;
          background: linear-gradient(to right, #10b981, #059669);
        }

        .cyber-tag {
          font-size: 9px;
          font-weight: 700;
          color: #047857;
          background: rgba(16, 185, 129, 0.1);
          border: 1px solid rgba(16, 185, 129, 0.2);
          padding: 3px 10px;
          border-radius: 99px;
          letter-spacing: 0.08em;
          display: inline-block;
        }

        .cyber-title {
          font-size: 18px;
          font-weight: 750;
          color: #111827;
          letter-spacing: -0.01em;
          margin-bottom: 6px;
        }

        .cyber-desc {
          font-size: 13px;
          color: #4b5563;
          line-height: 1.5;
        }

        .btn-cyber {
          background: #10b981;
          color: white !important;
          border: none;
          font-size: 13px;
          font-weight: 700;
          padding: 10px 20px;
          border-radius: 12px;
          text-decoration: none !important;
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
          transition: all 0.2s ease;
        }

        .btn-cyber:hover {
          background: #059669;
          transform: translateY(-1px);
        }

        /* Right Panels */
        .right-panel-card {
          background: #ffffff;
          border: 1px solid rgba(0, 0, 0, 0.04);
          border-radius: 24px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.02);
          overflow: hidden;
        }

        .panel-header {
          padding: 18px 20px;
          border-bottom: 1px solid #f3f4f6;
        }

        .panel-title {
          font-size: 14.5px;
          font-weight: 750;
          color: #111827;
          letter-spacing: -0.01em;
        }

        .panel-link {
          font-size: 12px;
          font-weight: 600;
          color: rgb(241, 94, 34);
          text-decoration: none !important;
        }

        .panel-body {
          padding: 13px 8px;
        }

        .upcoming-class-row {
          padding: 12px 0;
          border-bottom: 1px solid #f3f4f6;
        }

        .upcoming-class-row:last-child {
          border-bottom: none;
        }

        .class-row-title {
          font-size: 13.5px;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 2px !important;
        }

        .class-row-time {
          font-size: 12px;
          color: #6b7280;
          font-weight: 500;
        }

        .btn-class-join {
          background: #10b981;
          color: #ffffff !important;
          font-size: 11px;
          font-weight: 750;
          padding: 6px 14px;
          border-radius: 8px;
          text-decoration: none !important;
          transition: all 0.15s ease;
          box-shadow: 0 2px 6px rgba(16, 185, 129, 0.15);
        }

        .btn-class-join:hover {
          background: #059669;
          transform: translateY(-0.5px);
        }

        /* Recordings row - Video Play Icon color updates */
        .recording-row {
          padding: 10px 12px !important;
          border-radius: 12px !important;
          cursor: pointer !important;
          background: #ffffff !important;
          border: 1px solid #f3f4f6 !important;
          margin-bottom: 8px !important;
          transition: all 0.2s ease !important;
        }

        .recording-row:hover {
          background: #f9fafb !important;
          border-color: rgba(249, 115, 22, 0.2) !important;
          transform: translateY(-1px) !important;
        }

        /* Orange theme video icon initial stage with bg white, hover orange bg with video icon white border */
        .play-icon-circle {
          width: 32px !important;
          height: 32px !important;
          border-radius: 50% !important;
          background: #ffffff !important;
          border: 1.5px solid #f97316 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          flex-shrink: 0 !important;
          transition: all 0.2s ease !important;
        }

        .play-icon-circle svg {
          color: #f97316 !important;
          transition: all 0.2s ease !important;
        }

        .recording-row:hover .play-icon-circle {
          background: #f97316 !important;
          border-color: #f97316 !important;
        }

        .recording-row:hover .play-icon-circle svg {
          color: #ffffff !important;
        }

        .recording-row-title {
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #1f2937 !important;
          margin-bottom: 2px !important;
        }

        .recording-row-date {
          font-size: 11px !important;
          color: #6b7280 !important;
          font-weight: 550 !important;
        }

        /* CTA */
        .grey-cta {
          background: linear-gradient(135deg, #4f46e5 0%, #818cf8 100%) !important;
          border-radius: 24px;
          overflow: hidden;
          border: none;
          box-shadow: 0 12px 30px rgba(99, 102, 241, 0.15);
          position: relative;
        }
      `}</style>

      {weeklyFeedback === true ? (
        <div className="container">
          <Modal open={weeklyFeedback}>
            <WeeklyFeedback
              course={{ course_url: course_url, batch_id: batch_id }}
              show={""}
              onHandelClose={handleWeeklyFeedback}
            />
          </Modal>
        </div>
      ) : null}

      {course ? (
        <>
          {videoPermission === "active" ? (
            <div className="container py-4">
              <CourseBatchChat data={course} course_title={course.course_title} />

              <Modal open={modal} onClose={() => setmodal(false)}>
                <Box className="col-lg-4 col-11 p-3" sx={ModalStyle}>
                  <div className="modal-header d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0 fw-bold">Student access only</h5>
                    <CloseIcon className="click" onClick={() => setmodal(false)} />
                  </div>

                  <div className="p-1">
                    <p className="text-secondary small">
                      {course.mode === "free" && course_url === "website-development" ? (
                        <>You can access these resources only after your classes are commenced.</>
                      ) : (
                        <>Please register a paid course to access this feature.</>
                      )}
                    </p>

                    <div className="mt-4 d-flex justify-content-end gap-2">
                      <button
                        onClick={() => setmodal(false)}
                        className="btn btn-light rounded-pill btn-sm px-3"
                      >
                        Cancel
                      </button>
                      <Link
                        to="/courses"
                        className="btn btn-primary rounded-pill btn-sm px-3"
                      >
                        Browse Courses
                      </Link>
                    </div>
                  </div>
                </Box>
              </Modal>

              {/* Large Welcome Hero Section with Sub-Stats Cards */}
              <div className="luxury-card p-4 mb-4">
                {/* Blurred decorative circles behind */}
                <div className="bg-blur-circle top-0 end-0"></div>
                <div className="bg-blur-circle-alt bottom-0 start-0"></div>
                
                {/* Floating White Balls / Circles */}
                <div className="white-ball white-ball-1"></div>
                <div className="white-ball white-ball-2"></div>
                <div className="white-ball white-ball-3"></div>

                <div className="position-relative" style={{ zIndex: 1 }}>
                  
                  {/* Top Welcome Msg and Circular Gauge */}
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4">
                    <div className="d-flex align-items-center gap-3">
                      <div className="bg-gradient-ring" style={{ width: "72px", height: "72px" }}>
                        <div className="profile-inner">
                          {account.profile_pic ? (
                            <img
                              src={account.profile_pic}
                              alt="Profile"
                              className="w-100 h-100 object-fit-cover rounded"
                            />
                          ) : (
                            <span className="text-gradient">
                              {(account.first_name && account.first_name.charAt(0)) || "R"}
                            </span>
                          )}
                        </div>
                      </div>
                      <div>
                        <span className="badge-status-pro mb-1 d-inline-block">Active Student</span>
                        <h1 className="text-gradient-heading mb-0" style={{ fontSize: "24px" }}>
                          Welcome back, <span style={{ color: "var(--blue-theme)" }}>{account.first_name + " " + account.last_name}</span>.
                        </h1>
                        <p className="text-muted mb-0" style={{ fontSize: "13.5px", fontWeight: "550" }}>
                          {course.course_title} · {course.batch_name}
                        </p>
                      </div>
                    </div>
                    
                    <div className="d-flex align-items-center gap-2">
                      {/* Header actions */}
                      {course && course.id_card ? (
                        <button
                          className="btn-hero-action"
                          onClick={() => window.open(course.id_card, "_blank", "noopener,noreferrer")}
                        >
                          <CreditCard size={13} className="me-1" /> View ID Card
                        </button>
                      ) : null}
                      <button
                        className="btn-hero-action btn-hero-action-primary"
                        onClick={() => history.push(`/classes/${course_url}/batch${batch_id}`)}
                      >
                        <PlayCircleIcon className="me-1" style={{ fontSize: 14 }} /> Continue Learning
                      </button>
                    </div>
                  </div>

                  {/* Sub cards Row (Statistics inside Hero) */}
                  <div className="row g-3">
                    {/* Stat Card 1: Learning Streak / Progress */}
                    <div className="col-6 col-md-3">
                      <div className="hero-sub-card border-orange">
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <span className="sub-card-icon-dot orange"></span>
                          <span className="sub-card-label">LEARNING STREAK</span>
                        </div>
                        <div className="sub-card-value">1 <span className="sub-card-unit">day</span></div>
                        <span className="sub-card-badge orange">Keep going</span>
                      </div>
                    </div>

                    {/* Stat Card 2: Leaderboard Rank */}
                    <div className="col-6 col-md-3">
                      <div className="hero-sub-card border-yellow">
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <span className="sub-card-icon-dot yellow"></span>
                          <span className="sub-card-label">LEADERBOARD</span>
                        </div>
                        <div className="sub-card-value">#{course.rank || "N/A"}</div>
                        <span className="sub-card-badge yellow">Challenging</span>
                      </div>
                    </div>

                    {/* Stat Card 3: Doubt Tokens */}
                    <div className="col-6 col-md-3">
                      <div className="hero-sub-card border-blue">
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <span className="sub-card-icon-dot blue"></span>
                          <span className="sub-card-label">DOUBT TOKENS</span>
                        </div>
                        <div className="sub-card-value">{doubtStatistics.doubt_limit - doubtStatistics.doubt_score}</div>
                        <span className="sub-card-badge blue">Token count</span>
                      </div>
                    </div>

                    {/* Stat Card 4: Total points */}
                    <div className="col-6 col-md-3">
                      <div className="hero-sub-card border-green">
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <span className="sub-card-icon-dot green"></span>
                          <span className="sub-card-label">TOTAL POINTS</span>
                        </div>
                        <div className="sub-card-value">{course.total_marks || 0} <span className="sub-card-unit">pts</span></div>
                        <span className="sub-card-badge green">All-Time</span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              {/* Main Structure Layout */}
              <div className="row g-4">
                {/* Left 2/3 Area */}
                <div className="col-12 col-lg-8">
                  {/* Shortcut items grid - Changed to col-6 to put 2 blocks per row on all screen sizes */}
                  <div className="row g-3 mb-4">
                    {navigationItems.map((item) => (
                      <div key={item.id} className="col-6">
                        <Link 
                          to={item.link} 
                          className={`nav-shortcut-card d-flex align-items-center gap-3 p-3 h-100 ${item.hoverClass}`}
                        >
                          <div 
                            className="nav-shortcut-icon-wrapper" 
                            style={{ 
                              backgroundColor: item.bgColor, 
                              color: item.color,
                              transition: 'all 0.2s ease'
                            }}
                          >
                            <item.icon size={22} />
                          </div>
                          <div>
                            <h6 className="nav-shortcut-title mb-0">{item.label}</h6>
                            <p className="nav-shortcut-desc mb-0">{item.info}</p>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
 
                  {/* Premium Banners: Resource Center and Mock Challenges Side-by-Side with Background Images and Title Icons */}
                  <div className="row g-3 mb-4">
                    <div className="col-12 col-sm-6">
                      <Link to={`/resources/${course_url}/${batch_id}`} className="shortcut-banner resource-banner d-flex align-items-center w-100" style={{ minHeight: "120px" }}>
                        <div className="text-white position-relative" style={{ zIndex: 1 }}>
                          <h6 className="fw-bold mb-1 d-flex align-items-center gap-2">
                            <BookOpen size={18} /> Resource Center
                          </h6>
                          <p className="mb-0 text-white-50" style={{ fontSize: "12px" }}>PDFs, targets, & cheat sheets</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-12 col-sm-6">
                      <Link to={`/test-topics/mock-test/${course_url}`} className="shortcut-banner exam-banner d-flex align-items-center w-100" style={{ minHeight: "120px" }}>
                        <div className="text-white position-relative" style={{ zIndex: 1 }}>
                          <h6 className="fw-bold mb-1 d-flex align-items-center gap-2">
                            <Award size={18} /> Mock Challenges
                          </h6>
                          <p className="mb-0 text-white-50" style={{ fontSize: "12px" }}>Earn certification credentials</p>
                        </div>
                      </Link>
                    </div>
                  </div>

                  {/* Ethical Hacking Specific Terminal Sandbox UI */}
                  {(course.course_url === "ethical-hacking-free" ||
                    course.course_url === "ethical-hacking" ||
                    course.course_url === "ethical-hacking-specialization") && (
                    <div className="cyber-lab-card mb-4 p-4">
                      <div className="cyber-decor-top"></div>
                      <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
                        <div style={{ flex: 1, minWidth: "260px" }}>
                          <span className="cyber-tag mb-2">INTEGRATED LABS</span>
                          <h5 className="cyber-title">Hacking Challenges & CTF Sandbox</h5>
                          <p className="cyber-desc mb-0">
                            Enter a world of exploits, privilege escalation, and network penetration. Deploy sandbox targets and crack terminal flags directly in your browser.
                          </p>
                        </div>
                        <Link to="/hacking-challenges" target="_blank" className="btn-cyber mt-2 flex-shrink-0">
                          Deploy Target &rarr;
                        </Link>
                      </div>
                    </div>
                  )}

                  {/* Journey tracker timeline widget */}
                  {journey ? (
                    <div className="journey-tracker-card p-4 mb-4">
                      <h6 className="panel-title mb-4">Your Learning Streak & Route Map</h6>
                      <ProgressTracker journey={journey} progress={course.progress} />
                    </div>
                  ) : null}
                </div>

                {/* Right 1/3 Side Panel */}
                <div className="col-12 col-lg-4">
                  {/* Classes Calendar / Recordings panel */}
                  <div className="right-panel-card mb-4">
                    {upcominClasses && !previous_classes.length > 2 && upcominClasses.length > 0 ? (
                      <>
                        <div className="panel-header d-flex justify-content-between align-items-center">
                          <h6 className="panel-title mb-0">Upcoming Schedule</h6>
                          <Link to={`/classes/${course_url}/batch${batch_id}`} className="panel-link">View all &rarr;</Link>
                        </div>
                        <div className="panel-body">
                          {upcominClasses.map((cls) => (
                            <div key={cls.id} className="upcoming-class-row">
                              <div className="d-flex justify-content-between align-items-start gap-2">
                                <div>
                                  <h6 className="class-row-title">{cls.class_title}</h6>
                                  <span className="class-row-time">
                                    {dateFormat(cls.class_starts, "ddd, mmm d")} · {dateFormat(cls.class_starts, "h:MM TT")}
                                  </span>
                                </div>
                                <Link to={`/classes/${course_url}/batch${batch_id}`} className="btn-class-join flex-shrink-0">Join</Link>
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="panel-header d-flex justify-content-between align-items-center">
                          <h6 className="panel-title mb-0 d-flex align-items-center">
                            <Video size={16} className="me-2" style={{ color: "var(--blue-theme)" }} />
                            Class Recordings
                          </h6>
                          <Link to={`/recordings/${course_url}/${batch_id}/0`} className="panel-link">View all &rarr;</Link>
                        </div>
                        <div className="panel-body">
                          {previous_classes && previous_classes.length > 0 ? (
                            previous_classes.slice(0, 3).map((item) => (
                              <div
                                key={item.id}
                                className="recording-row d-flex align-items-center gap-3"
                                onClick={() => history.push(`/recordings/${item.course_url}/${item.batch_id}/${item.id}`)}
                              >
                                <div className="play-icon-circle flex-shrink-0">
                                  <PlayCircleIcon style={{ fontSize: 20 }} />
                                </div>
                                <div className="d-flex align-items-center justify-content-between flex-grow-1 overflow-hidden">
                                  <h6 className="recording-row-title text-truncate mb-0 me-3">{item.class_title || "Untitled Class"}</h6>
                                  <span className="recording-row-date flex-shrink-0">
                                    {item.class_starts ? item.class_starts.split(" ")[0] : "Recent"}
                                  </span>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="text-center py-4 text-muted small">No class recordings loaded yet.</div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
 
                  {/* Leaderboard Panel - Limit changed to 3 */}
                  <div className="right-panel-card mb-4 p-4">
                    <TeamLeaderboard
                      courseUrl={course_url}
                      batchId={batch_id}
                      teamId={course.team_id}
                      limit={3}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-center pb-5" style={{ backgroundColor: 'rgb(0,0,0,0.5)' }} >
              <div className="col-lg-7 col-md-7 mt-2 col-12 col-xs-12 bg-white p-3 shadow rounded">
                <video className="col-12" controls="nodownload" src={ENDPOINT+"/data/videos/course-dashboard-access.mp4"}></video>
                <div className="d-flex click btn align-items-center justify-content-between">
                  <h4 className="text-secondary">How to Access the Dashboard</h4>
                  <UiButton>
                    <button onClick={updateVidePermissions} className="mt-2" >
                      <span>Continue </span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 74 74"
                        height="34"
                        width="34"
                      >
                        <circle strokeWidth="3" stroke="black" r="35.5" cy="37" cx="37"></circle>
                        <path
                          fill="black"
                          d="M25 35.5C24.1716 35.5 23.5 36.1716 23.5 37C23.5 37.8284 24.1716 38.5 25 38.5V35.5ZM49.0607 38.0607C49.6464 37.4749 49.6464 36.5251 49.0607 35.9393L39.5147 26.3934C38.9289 25.8076 37.9792 25.8076 37.3934 26.3934C36.8076 26.9792 36.8076 27.9289 37.3934 28.5147L45.8787 37L37.3934 45.4853C36.8076 46.0711 36.8076 47.0208 37.3934 47.6066C37.9792 48.1924 38.9289 48.1924 39.5147 47.6066L49.0607 38.0607ZM25 38.5L48 38.5V35.5L25 35.5V38.5Z"
                        ></path>
                      </svg>
                    </button>
                  </UiButton>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="container pb-5 d-flex justify-content-between">
          <div className="col-lg-6">
            <Skeleton className="mb-2" variant="text" height={400} />
            <div className="grid lg-grid-4 course-options grid-3 mt-3 mb-3">
              {[...Array(8)].map((_, i) => (
                <Skeleton key={i} className="mb-2 mt-2" variant="text" height={200} />
              ))}
            </div>
          </div>
          <div className="col-lg-5">
            <Skeleton className="mb-2 mt-2" variant="text" height={200} />
            <div className="my-3">
              {[...Array(4)].map((_, i) => (
                <Skeleton key={i} className="mb-2 mt-2" variant="text" height={80} />
              ))}
            </div>
            <Skeleton className="mb-2 mt-2" variant="text" height={200} />
          </div>
        </div>
      )}
    </div>
  );
};

export default MyCourseDashboard;

export const UiButton = styled.div`
  @media (min-width: 769px) {
    .custom-margin {
      margin-top: -40px;
    }
  }

  button {
    cursor: pointer;
    font-weight: 700;
    transition: all 0.2s;
    padding: 10px 20px;
    border-radius: 100px;
    background: rgb(0, 96, 239);
    border: 1px solid transparent;
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #fff;
  }

  button:hover {
    background: rgb(1, 147, 226);
  }

  button > svg {
    width: 34px;
    margin-left: 10px;
    transition: transform 0.3s ease-in-out;
    fill: #fff;
  }

  button:hover svg {
    transform: translateX(5px);
    fill: rgb(1, 147, 226);    
  }

  button:active {
    transform: scale(0.95);
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  }
`;
